import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReviewStockTakeLotMutationVariables = Types.Exact<{
  input: Types.ReviewStockTakeLotInput;
}>;


export type ReviewStockTakeLotMutation = { readonly __typename?: 'Mutation', readonly reviewStockTakeLot: { readonly __typename?: 'StockTakeLotAddition', readonly id: string, readonly quantityDifference: number, readonly stockTake: { readonly __typename?: 'StockTake', readonly id: string, readonly aggregateInfo: { readonly __typename?: 'StockTakeAggregateInfo', readonly totalLotCount: number, readonly reviewedLotCount: number } } } | { readonly __typename?: 'StockTakeLotUpdate', readonly id: string, readonly quantityDifference: number, readonly stockTake: { readonly __typename?: 'StockTake', readonly id: string, readonly aggregateInfo: { readonly __typename?: 'StockTakeAggregateInfo', readonly totalLotCount: number, readonly reviewedLotCount: number } } } };


export const ReviewStockTakeLotDocument = gql`
    mutation reviewStockTakeLot($input: ReviewStockTakeLotInput!) {
  reviewStockTakeLot(input: $input) {
    ... on StockTakeLotAddition {
      id
      quantityDifference
      stockTake {
        id
        aggregateInfo {
          totalLotCount
          reviewedLotCount
        }
      }
    }
    ... on StockTakeLotUpdate {
      id
      quantityDifference
      stockTake {
        id
        aggregateInfo {
          totalLotCount
          reviewedLotCount
        }
      }
    }
  }
}
    `;
export type ReviewStockTakeLotMutationFn = Apollo.MutationFunction<ReviewStockTakeLotMutation, ReviewStockTakeLotMutationVariables>;

/**
 * __useReviewStockTakeLotMutation__
 *
 * To run a mutation, you first call `useReviewStockTakeLotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewStockTakeLotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewStockTakeLotMutation, { data, loading, error }] = useReviewStockTakeLotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewStockTakeLotMutation(baseOptions?: Apollo.MutationHookOptions<ReviewStockTakeLotMutation, ReviewStockTakeLotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewStockTakeLotMutation, ReviewStockTakeLotMutationVariables>(ReviewStockTakeLotDocument, options);
      }
export type ReviewStockTakeLotMutationHookResult = ReturnType<typeof useReviewStockTakeLotMutation>;
export type ReviewStockTakeLotMutationResult = Apollo.MutationResult<ReviewStockTakeLotMutation>;
export type ReviewStockTakeLotMutationOptions = Apollo.BaseMutationOptions<ReviewStockTakeLotMutation, ReviewStockTakeLotMutationVariables>;